import '../../../../../node_modules/jquery.maskedinput/src/jquery.maskedinput';

export default new class Input {
  constructor() {
    this.inputWrapSelector = 'input';
    this.inputWrapFilledSelector = 'input_filled';
    this.inputFieldSelector = 'input__field';
    this.inputFieldFilledSelector = 'input__field_filled';
    this.inputLabelSelector = 'input__label';
    this.inputLabelElevatedSelector = 'input__label_elevated';
    this.inputLabelTransitionSelector = 'input__label_elevated_transition';
    this.errorSelector = 'validation-error';

    this.selectPhoneSelector = 'prefix-phone__select';
    this.inputPhoneSelector = 'input-phone__field';

    this.init();
    this.handler();
    this.setPhoneMask();
  }

  init() {
    const inputs = document.querySelectorAll(`.${this.inputFieldSelector}`);
    const isTransition = false;

    inputs.forEach((input) => {
      if (input.value.length) {
        this.labelUp(input, isTransition);
      }
    });
  }

  handler() {
    const input = $(`.${this.inputFieldSelector}`);

    if (!input.length) return;

    $(document).on('focus', `.${this.inputFieldSelector}`, ({ target }) => {
      this.labelUp(target);
    });

    $(document).on('blur', `.${this.inputFieldSelector}`, ({ target }) => {
      this.labelDown(target);
      this.checkChange(target);
    });

    $(document).on('change', `.${this.inputFieldSelector}`, ({ target }) => {
      this.labelDown(target);
      this.checkChange(target);
    });
  }

  static checkInputState(input) {
    const value = $(input).val().trim();
    return value.length > 0;
  }

  checkChange(target) {
    if (!target.hasAttribute('required')) return;

    if ($(target).val().trim().length > 0) {
      $(target).addClass(this.inputFieldFilledSelector);
    } else {
      $(target).removeClass(this.inputFieldFilledSelector);
    }
  }

  findLabel(input) {
    return $(input).siblings(`.${this.inputLabelSelector}`);
  }

  labelUp(input, isTransition = true) {
    this.findLabel(input).addClass(this.inputLabelElevatedSelector);
    if (isTransition) {
      this.findLabel(input).addClass(this.inputLabelTransitionSelector);
    }
  }

  labelDown(input) {
    const inputState = this.constructor.checkInputState(input);

    if (!inputState) {
      this.findLabel(input).removeClass([
        this.inputLabelElevatedSelector,
        this.inputLabelTransitionSelector,
      ]);
    }
    this.findLabel(input).addClass([
      this.inputLabelElevatedSelector,
    ]);
  }

  setPhoneMask() {
    $(`.${this.inputPhoneSelector}`).mask('+7 (999) 999-99-99');
    $(document).on('change', `.${this.selectPhoneSelector}`, ({ target }) => {
      $(`.${this.inputPhoneSelector}`).val('');
      if (target.value !== '+7') {
        $(`.${this.inputPhoneSelector}`).mask(`${target.value} (99) 999-99-99`);
      } else {
        $(`.${this.inputPhoneSelector}`).mask('+7 (999) 999-99-99');
      }
    });
  }
}();
